//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["object1","object2"],"GetComparedObjects",{},0,0],[[],"GetIsCustomizationDifferent",{R_:{customizationDifferent:''}},0,0],[[],"GetIsValueDifferent",{R_:{valueDifferent:''}},0,0],[[],"GetTypeOfObject",{R_:{type:''}},0,0]],[]];
SPLM.CAM.ComparePartsResult = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ComparePartsResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ComparePartsResult.ObjectTypes = Object.freeze({
    "Operation" : "Operation", "TaskViewObject" : "TaskViewObject", "MethodViewObject" : "MethodViewObject", "GeometryViewObject" : "GeometryViewObject", "MachineViewObject" : "MachineViewObject"});

export default SPLM;